import React, { useState } from "react";
import "../styles/FAQsPage.css";

const FAQsPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What types of bicycles do you offer?",
      answer:
        "We offer a wide range of mountain bikes, road bikes, hybrid bikes, and kids’ bicycles designed for both performance and comfort."
    },
    {
      question: "Do you provide home delivery for bicycles?",
      answer:
        "Yes, we provide doorstep delivery across India. Shipping charges may vary depending on your location."
    },
    {
      question: "Can I return or exchange my bike?",
      answer:
        "Absolutely! You can request a return or exchange within 7 days of delivery, provided the product is unused and in original condition."
    },
    // {
    //   question: "Do you offer servicing or repairs?",
    //   answer:
    //     "Yes, we provide professional servicing and repairs for all types of bicycles at our authorized SAC MTB service centers."
    // },
    {
      question: "How can I participate in SAC MTB tournaments?",
      answer:
        "Keep an eye on our 'Game' section or subscribe to our newsletter to get early access to upcoming events and registrations."
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-page">
      <div className="faq-header">
        <h1>Frequently Asked <span>Questions</span></h1>
        <p>Find answers to the most common questions about SAC MTB bikes, services, and events.</p>
      </div>

      <div className="faq-container">
        {faqs.map((item, index) => (
          <div
            key={index}
            className={`faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFAQ(index)}
          >
            <div className="faq-question">
              <h3>{item.question}</h3>
              <span>{activeIndex === index ? "−" : "+"}</span>
            </div>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQsPage;
